import React, { useEffect, useState } from "react";
import * as validationService from "../add-device-modal/validationService";
import { debug } from "../../utils";
import { connect } from "react-redux";

function WinRmPasswordField({ value, onChange, error, passwordChanged, onChangePasswordClick, centralCredentialId, disabled }) {

    const [disableInput, setDisableInput] = useState(true)
    const [showChangeBtn, setShowChangeBtn] = useState(true)  

    const ProcessData = async () => {
        if (centralCredentialId && centralCredentialId > 0) {
            validationService.cleanValidation('winrmPassword');            
            setShowChangeBtn(false);
            setDisableInput(true);
            onChange('');
        } 
        else {
            validationService.validateNotEmpty(value, 'winrmPassword');
            if (passwordChanged && showChangeBtn && disableInput) {
                setShowChangeBtn(true);
                setDisableInput(false);
            } 
            else if (passwordChanged && showChangeBtn && !disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            } 
            else if (passwordChanged && !showChangeBtn && disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            }
            else if (passwordChanged && !showChangeBtn && !disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            }  
            

            else if (!passwordChanged && !showChangeBtn && !disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            } 
            else if (!passwordChanged && !showChangeBtn && disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            }
            else if (!passwordChanged && showChangeBtn && disableInput) {
                setShowChangeBtn(true);
                setDisableInput(true);
            } 
             
            else {
                setDisableInput(true); 
            }         
        }
        return () => validationService.cleanValidation('winrmPassword');
    }
    useEffect(() => {
        ProcessData();
        /* eslint-disable react-hooks/exhaustive-deps */
      
    }, [value, centralCredentialId])

    // useEffect(() => {
    //     validationService.validateNotEmpty(value, 'winrmPassword');
    //     return () => validationService.cleanValidation('winrmPassword');
    // }, [value])

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="winrm_password">Password <span className="modal-v2-required-mark">*</span></label>
                <div className="modal-v2-field-action-row">
                    <input className={`form-control oct_field ${error && 'border-danger'}`}
                        id="winrm_password-key"
                        type="password"
                        value={centralCredentialId ? '' : value}
                        disabled={disableInput}
                        onChange={disableInput ? null : event => onChange(event.target.value)} />
                    {showChangeBtn
                        && value
                        && <button type="button"
                            className="modal-v2-btn modal-v2-btn-primary modal-v2-inline-change-btn"
                            onClick={!disableInput ? null : () => onChangePasswordClick()}>
                            Change
                        </button>}
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("WinRmPasswordField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.winrmPassword,
    }
}

export default connect(mapStateToProps)(WinRmPasswordField);
